import { render, staticRenderFns } from "./PerfectInfo.vue?vue&type=template&id=6d8c850d&scoped=true"
import script from "./PerfectInfo.vue?vue&type=script&lang=js"
export * from "./PerfectInfo.vue?vue&type=script&lang=js"
import style0 from "./PerfectInfo.vue?vue&type=style&index=0&id=6d8c850d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d8c850d",
  null
  
)

export default component.exports